import { useEffect, useState } from "react";
import styled from "styled-components";
import { Form, Input, Button, Select } from "antd";

import MasterService from "../../service/_Master";
import ProfileService from "../../service/Profile";
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;

const FormExtend = styled(FormControl)`
    .form-button{
    padding-left: 0;
    padding-right: 0;
    button{
        width: 40%;
        color: white;
        background-color: #007BFF ;
    }

    button:hover{
        background-color: white;
        color : #007BFF;
        border-radius: 5px;
        transition: 0.3s;
    }
    }
    .form-item__btn-cancel{
        background-color: #1d1d1d !important;
    }
    .form-item__btn-cancel:hover{
        background-color: white !important;
        color : #1d1d1d;
        border-radius: 5px;
        transition: 0.3s;
        border-color: #1d1d1d;
    }
`;

export default function FormProfile(props) {

    const [data, setData] = useState({})
    const [ org, setOrg ] = useState([])
    const [ form ] = Form.useForm();

    useEffect(() => {
        const init = async () => {
            let orgs = await MasterService.getOrg()
            if(orgs) setOrg(orgs)
            let user = await ProfileService.search();
            if(user) setData(user)

            form.setFieldsValue({
                email : user.email,
                orgId: user.org_id,
                firstName : user.first_name,
                lastName : user.last_name,
                tel : user.tel
    
            });
        }
        init()
    }, [form, props.data]);

    const onFinish = async(values) => {
        let data = {
            firstName: values.firstName,
            lastName: values.lastName,
            tel: values.tel
        }
        let result = await ProfileService.update(data)
        if(result){
            form.setFieldsValue({
                firstName : result.first_name,
                lastName : result.last_name,
                tel : result.tel
            })
        }
    };

    const formInput = () => {
        return (
            <>
                <Form.Item
                    name={["email"]}
                    className="form-item__email"
                    label="อีเมล"
                >
                    <Input disabled={true}/>
                </Form.Item>
                <Form.Item
                    name={["orgId"]}
                    className="form-item__org-id"
                    label="หน่วยงาน/องค์กร"
                >
                    <Select placeholder="กรุณาเลือก" allowClear disabled>
                        <Option key={0} value={0}>หน่วยงาน/องค์กรอิสระ</Option>
                        {org.map((item) => (<Option key={item.id} value={item.id}>{item.disp_name}</Option>))};
                    </Select>
                </Form.Item>
                <Form.Item
                    name={["firstName"]}
                    className="form-item__first-name"
                    label="ชื่อ"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    name={["lastName"]}
                    className="form-item__last-name"
                    label="นามสกุล"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    name={["tel"]}
                    className="form-item__tel"
                    label="เบอร์โทรศัพท์"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Input autoComplete="off"
                        onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]+/g, "");
                            form.setFieldsValue({ tel: value });
                        }}
                    />
                </Form.Item>
                <Form.Item className="form-button">
                    <Button
                        className="form-item__btn-submit btn-primary"
                        htmlType="submit"
                    >
                        อัปเดทข้อมูล
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormExtend
            name={"form-user-profile"}
            column={2}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : ""}
        ></FormExtend>
    );
}
